import axios from "./api"

const sessionsApi = {
    getSystemStatus() {
        return axios.get(`/api/system/status`);
    },
}

export default sessionsApi;
